// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/stopBtnRepeat.js' // 这是防止高迸发点击
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import dragVerify from 'vue-drag-verify2'
import SlideVerify from "vue-monoplasty-slide-verify";

// 全局组件高德地图
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: '9f18c3d4010ebff882c301f3d9b9669d',
  plugin: [
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PlaceSearch',
    "AMap.Autocomplete",
    'AMap.Geolocation',
    'AMap.Geocoder',
    "AMap.AMapUI",// UI组件
  ],
  v: '1.4.4',// 默认高德 sdk 版本为 1.4.4
  uiVersion: '1.0'
})
window._AMapSecurityConfig = {
  securityJsCode:'15580c6c6681fe491877ce938b43e251', //2ddb37822233626e5faff3783f5323a0
}
Vue.use(SlideVerify);
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.use(iView)
Vue.use(dragVerify)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js